import AppDropDownMenu from '@/common/components/form-inputs/AppDropDownMenu';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
	NotificationReadStatus,
	NotificationSummaryFilter,
} from '../notificationSummaryFilter';

interface NotificationSummaryPageFilterSectionProps {
	/**
	 * Selection actions, right-aligned in the spare half of the filter row.
	 *
	 * They live here rather than in a row of their own so that nothing shifts when
	 * a selection starts or ends: this Grid item holds its six columns whether or
	 * not anything renders into it, and the filter fields keep their own.
	 */
	action?: ReactNode;
}

export default function NotificationSummaryPageFilterSection({
	action,
}: NotificationSummaryPageFilterSectionProps) {
	const { t } = useTranslation();
	const { control } = useFormContext<NotificationSummaryFilter>();

	const readStatusOptions = [
		{ id: NotificationReadStatus.all, name: t('notification.statusAll') },
		{ id: NotificationReadStatus.unread, name: t('notification.statusUnread') },
		{ id: NotificationReadStatus.read, name: t('notification.statusRead') },
	];

	return (
		<Grid container rowSpacing={2} columnSpacing={1} alignItems='center'>
			<Grid size={4}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppDropDownMenu
					control={control}
					name='readStatus'
					label={t('notification.readStatus')}
					options={readStatusOptions}
				/>
			</Grid>
			<Grid
				size={6}
				sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5 }}
			>
				{action}
			</Grid>
		</Grid>
	);
}
